module.exports = __webpack_public_path__ + "img/network.d7987a02.svg";